import Vue from 'vue';
import Vuex from 'vuex';
import copy from '@/assets/data/copy-doc.json';

const pages: string[] = [
  'Name',
  'WhatAreYouHaving',
  'WhichJerseyShore',
  'WhichClub',
  'WhatAreYouEating',
  'WhereAreYouVacationing',
  'WhatsYourSignature',
];

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isMobile: false,
    jerzday: copy.jerzday,
    pages,
    currentPage: 'Start',
    firstName: '',
    lastName: '',
    gender: {
      question: copy.gender.question,
      selected: '',
    },
    castMember: {
      question: copy.castMember.question,
      questionMobile: copy.castMember.questionMobile,
      options: copy.castMember.options,
      selected: createRandomOption(copy.castMember.options),
    },
    club: {
      question: copy.club.question,
      questionMobile: copy.club.questionMobile,
      options: copy.club.options,
      selected: createRandomOption(copy.club.options),
    },
    food: {
      question: copy.food.question,
      questionMobile: copy.food.questionMobile,
      options: copy.food.options,
      selected: createRandomOption(copy.food.options),
    },
    location: {
      question: copy.location.question,
      questionMobile: copy.location.questionMobile,
      options: copy.location.options,
      selected: createRandomOption(copy.location.options),
    },
    signature: {
      question: copy.signature.question,
      questionMobile: copy.signature.questionMobile,
      options: copy.signature.options,
      selected: createRandomOption(copy.signature.options),
    },
  },
  mutations: {
    set_firstName(state, val) {
      state.firstName = val;
    },
    set_lastName(state, val) {
      state.lastName = val;
    },
    set_currentPage(state, val) {
      state.currentPage = val;
    },
    set_gender(state, val) {
      state.gender.selected = val;
    },
    set_castMember(state, val) {
      state.castMember.selected = val;
    },
    set_club(state, val) {
      state.club.selected = val;
    },
    set_food(state, val) {
      state.food.selected = val;
    },
    set_location(state, val) {
      state.location.selected = val;
    },
    set_signature(state, val) {
      state.signature.selected = val;
    },
    clear(state) {
      state.currentPage = 'Start';
      state.firstName = '';
      state.lastName = '';
      state.gender.selected = '';
      state.castMember.selected = createRandomOption(copy.castMember.options);
      state.club.selected = createRandomOption(copy.club.options);
      state.food.selected = createRandomOption(copy.food.options);
      state.location.selected = createRandomOption(copy.location.options);
      state.signature.selected = createRandomOption(copy.signature.options);
    },
    resize(state, val) {
      state.isMobile = val < 850;
    },
  },
  actions: {},
  getters: {
    pageIndex(state) {
      return state.pages.indexOf(state.currentPage);
    },
  },
});

function createRandomOption(options: string[]): string {
  const index = Math.floor(Math.random() * options.length);
  return options[index];
}

window.addEventListener('resize', onResize);

function onResize() {
  store.commit('resize', window.innerWidth);
}

export default store;
